import { PermissionService } from './../../../service/permission.service';
import { BillOrderModuleId, BillPaymentModuleId, LocationModuleId, PurchaseOrderModuleId, TaskModuleId, VendorCreditModuleId, VendorModuleId, VendorReturnModuleId } from './../../../modules/shared/constants/modules.constant';
import { Component, OnInit } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { AccountModuleId, LeadModuleId, ProductModuleId, EstimateOrderModuleId, SOModuleId, InvoiceOrderModuleId, OpportunityModuleId } from 'src/app/modules/shared/constants/modules.constant';
import { ObjectNames } from 'src/app/shared/constants';
@Component({
    selector: 'app-system-template',
    templateUrl: './template.component.html',
    styleUrls: ['./template.component.scss']
})
export class TemplateComponent implements OnInit {

    itemsEmails: MenuItem[];
    items: MenuItem[];
    moduleId: number = AccountModuleId;
    userPermissions: any = null;

    constructor(
        private permissionService: PermissionService
    ) {

     }

    ngOnInit(): void {
        this.userPermissions = this.permissionService.getPemrissionData();
        this.generateEmailMenus();
        this.items = [
            {
                label: 'Estimates',
            },
            {
                label: 'Sales Orders',
                items: [
                    {
                        label: 'Pick Slip',
                    },
                    {
                        label: 'Pack Slip',
                    },
                    {
                        label: 'Salse Order',
                    },
                ]
            },
            {
                label: 'Invoices',
            },
            {
                label: 'Credit Memo',
            },
            {
                label: 'Customer Returns',
            },
            {
                label: 'Vendor Returns',
            }
        ];
    }

    getModulePermission(objectName: string){
        const userPermission = this.userPermissions.find(obj => obj.objectName === objectName);
        const menuPermission = userPermission ? (userPermission.permissions.find(obj => obj.statusId == 1) ? true : false) : false;

        return menuPermission;
    }

    generateEmailMenus() {

        this.itemsEmails = [
            {
                label: 'Accounts',
                visible: this.getModulePermission(ObjectNames.ACCOUNT),
                styleClass: this.moduleId == AccountModuleId ? 'menu-active' : '',
                command: () => {
                    this.moduleId = AccountModuleId;
                    this.generateEmailMenus();
                }
            },
            {
                label: 'Leads',
                visible: this.getModulePermission(ObjectNames.LEAD),
                styleClass: this.moduleId == LeadModuleId ? 'menu-active' : '',
                command: () => {
                    this.moduleId = LeadModuleId;
                    this.generateEmailMenus();
                }
            },
            {
                label: 'Opportunity',
                visible: this.getModulePermission(ObjectNames.OPPORTUNITY),
                styleClass: this.moduleId == OpportunityModuleId ? 'menu-active' : '',
                command: () => {
                    this.moduleId = OpportunityModuleId;
                    this.generateEmailMenus();
                }
            },
            {
                label: 'Products',
                visible: this.getModulePermission(ObjectNames.PRODUCT),
                styleClass: this.moduleId == ProductModuleId ? 'menu-active' : '',
                command: () => {
                    this.moduleId = ProductModuleId;
                    this.generateEmailMenus();
                }
            },
            {
                label: 'Estimate',
                visible: this.getModulePermission(ObjectNames.Est_Menu_Object),
                styleClass: this.moduleId == EstimateOrderModuleId ? 'menu-active' : '',
                command: () => {
                    this.moduleId = EstimateOrderModuleId;
                    this.generateEmailMenus();
                }
            },
            {
                label: 'Sales Order',
                visible: this.getModulePermission(ObjectNames.SALES_ORDER),
                styleClass: this.moduleId == SOModuleId ? 'menu-active' : '',
                command: () => {
                    this.moduleId = SOModuleId;
                    this.generateEmailMenus();
                }
            },
            {
                label: 'Invoice',
                visible: this.getModulePermission(ObjectNames.INVOICE),
                styleClass: this.moduleId == InvoiceOrderModuleId ? 'menu-active' : '',
                command: () => {
                    this.moduleId = InvoiceOrderModuleId;
                    this.generateEmailMenus();
                }
            },
            {
                label: 'Vendor',
                visible: this.getModulePermission(ObjectNames.Vendor),
                styleClass: this.moduleId == VendorModuleId ? 'menu-active' : '',
                command: () => {
                    this.moduleId = VendorModuleId;
                    this.generateEmailMenus();
                }
            },
            
            /////new tab added
            {
                label: 'Purchase',
                visible: this.getModulePermission(ObjectNames.PURCHASE),
                styleClass: this.moduleId == PurchaseOrderModuleId ? 'menu-active' : '',
                command: () => {
                    this.moduleId = PurchaseOrderModuleId;
                    this.generateEmailMenus();
                }
            },
            {
                label: 'Bill',
                visible: this.getModulePermission(ObjectNames.Bill),
                styleClass: this.moduleId == BillOrderModuleId ? 'menu-active' : '',
                command: () => {
                    this.moduleId = BillOrderModuleId;
                    this.generateEmailMenus();
                }
            },
            {
                label: 'Vendor RMA',
                visible: this.getModulePermission(ObjectNames.Vendor_Returns),
                styleClass: this.moduleId == VendorReturnModuleId ? 'menu-active' : '',
                command: () => {
                    this.moduleId = VendorReturnModuleId;
                    this.generateEmailMenus();
                }
            },
            {
                label: 'Vendor Credit',
                visible: this.getModulePermission(ObjectNames.Vendor_Credit),
                styleClass: this.moduleId == VendorCreditModuleId ? 'menu-active' : '',
                command: () => {
                    this.moduleId = VendorCreditModuleId;
                    this.generateEmailMenus();
                }
            },
            {
                label: 'Payment Receipts',
                visible: this.getModulePermission(ObjectNames.Bill_Payment),
                styleClass: this.moduleId == BillPaymentModuleId ? 'menu-active' : '',
                command: () => {
                    this.moduleId = BillPaymentModuleId;
                    this.generateEmailMenus();
                }
            },
            {
                label: 'Location',
                visible: this.getModulePermission(ObjectNames.WAREHOUSE),
                styleClass: this.moduleId == LocationModuleId ? 'menu-active' : '',
                command: () => {
                    this.moduleId = LocationModuleId;
                    this.generateEmailMenus();
                }
            },
            {
                label: 'Task',
                visible: this.getModulePermission(ObjectNames.TASK),
                styleClass: this.moduleId == TaskModuleId ? 'menu-active' : '',
                command: () => {
                    this.moduleId = TaskModuleId;
                    this.generateEmailMenus();
                }
            }
        ];
    }

}
